import React from 'react';
import Icon from '../home/Icon';
import './StatsCard.css';

// iconColor (optional): CSS color of the header icon, e.g. colorVar(key) of an add-on with an own color — a theme
// token, so it follows light/dark mode. Without it the icon keeps the tertiary text color.
function StatsCard({ title, value, suffix = '', icon, tone = 'neutral', sub, subLines, iconColor }) {
  const hasSubLines = subLines && subLines.filter(Boolean).length > 0;
  return (
    <div
      className={`statsCard tone-${tone}${iconColor ? ' hasIconColor' : ''}`}
      style={iconColor ? { '--stats-card-icon-color': iconColor } : undefined}
    >
      <div className="statsCardHeader">
        {icon && <Icon className="statsCardIcon" icon={icon} />}
        <p className="statsCardTitle">{title}</p>
      </div>
      <p className="statsCardValue">
        {value}
        {suffix && <span className="statsCardSuffix">{suffix}</span>}
      </p>
      {hasSubLines ? (
        <div className="statsCardSubLines">
          {subLines.filter(Boolean).map((line, i) => (
            <span key={i} className="statsCardSubLine">{line}</span>
          ))}
        </div>
      ) : (
        <p className={`statsCardSub ${!sub ? 'empty' : ''}`}>{sub || '\u00A0'}</p>
      )}
    </div>
  );
}

export default StatsCard;
